import moment from 'moment'

import { PayAndGoSession } from '../types'

function isPayAndGoSessionMetadata(
  value: any,
): value is { metadata: PayAndGoSession } {
  if (typeof value.metadata?.sessionId !== 'string') {
    return false
  }

  if (typeof value.metadata.modified !== 'number') {
    return false
  }

  if (
    typeof value.metadata.selectedItems !== 'object' ||
    !Array.isArray(value.metadata.selectedItems)
  ) {
    return false
  }

  const modified = moment(value.metadata.modified)

  if (!modified.isValid()) {
    return false
  }

  // Add more checks if needed

  return true
}

export default isPayAndGoSessionMetadata
